module.exports = __webpack_public_path__ + "img/2.a8664c89.png";